// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The 5px/#ccc bar was technically there but read as an empty strip under the
   last row, so the horizontal one looked missing. Keep it slim, give it a track
   and enough contrast to be spotted. */
.table .ant-table-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table .ant-table-body::-webkit-scrollbar-track {
  background-color: #f0f0f0;
}

.table .ant-table-body::-webkit-scrollbar-thumb {
  background-color: #a3a3a3;
  border-radius: 4px;
}

.table .ant-table-body::-webkit-scrollbar-thumb:hover {
  background-color: #7a7a7a;
}

/* Firefox */
.table .ant-table-body {
  scrollbar-width: thin;
  scrollbar-color: #a3a3a3 #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/unity-ui-common/Components/ReTable/Styles.css"],"names":[],"mappings":"AAAA;;uCAEuC;AACvC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,gCAAgC;AAClC","sourcesContent":["/* The 5px/#ccc bar was technically there but read as an empty strip under the\n   last row, so the horizontal one looked missing. Keep it slim, give it a track\n   and enough contrast to be spotted. */\n.table .ant-table-body::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.table .ant-table-body::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n}\n\n.table .ant-table-body::-webkit-scrollbar-thumb {\n  background-color: #a3a3a3;\n  border-radius: 4px;\n}\n\n.table .ant-table-body::-webkit-scrollbar-thumb:hover {\n  background-color: #7a7a7a;\n}\n\n/* Firefox */\n.table .ant-table-body {\n  scrollbar-width: thin;\n  scrollbar-color: #a3a3a3 #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
